export default __webpack_public_path__ + "static/clustermesh-4-1a200e569e979d92696822a58c5beda4.png";